<template>
  <v-flex xs12 pt-0 mt-1 style="cursor: pointer" @click.prevent="toogleView">
    <v-layout row wrap>
      <v-flex xs12 py-0>
        <v-container py-3 px-0>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap body-1>
                <v-flex xs6 sm2 py-0 order-xs1 order-sm1>
                  {{receiver_social_name}}
                </v-flex>
                <v-flex xs12 sm6 py-0 order-xs5 order-sm2>
                  <div class="hidden-xs-only">
                    {{l(record.value, record.currency)}} <span class="silver-color">{{i18n('convertidos para')}}</span> {{l(record.exchanged_value, record.exchange_currency)}} ({{record.exchange_rate}})
                  </div>
                  <div class="hidden-sm-and-up">
                    {{l(record.value, record.currency)}} <span class="silver-color">{{i18n('convertidos para')}}</span> {{l(record.exchanged_value, record.exchange_currency)}}
                  </div>
                  <div class="hidden-sm-and-up">
                    {{i18n('Câmbio')}} {{record.exchange_rate}}
                  </div>
                </v-flex>
                <v-flex xs6 sm2 py-0 text-sm-center order-xs7 order-sm3>
                  <span class="silver-color" v-if="record.is_canceled === true">
                    {{ i18n('Cancelada') }}
                  </span>
                  <span class="silver-color" v-else-if="record.approved_by">
                    {{ i18n('Aprovado por') }}
                  </span>
                  <span class="silver-color" v-else>
                    {{ i18n('Aguardando') }}
                  </span>
                </v-flex>
                <v-flex xs6 sm2 py-0 text-sm-right order-xs3 order-sm4>
                  <span v-if="hasBankTransactions" class="silver-color">
                    {{i18n('Transações')}}: {{visibleTransactions.length}}
                  </span>
                </v-flex>
                <v-flex xs6 sm2 py-0 order-xs2 text-sm-left text-xs-right order-sm5>
                  {{humanExchangeDate}} {{humanExchangeTime}}
                </v-flex>
                <v-flex xs12 sm6 py-0 order-xs6 order-sm6>
                  <div v-if="record.currency != record.exchange_currency">
                    <span class="silver-color">IOF</span> {{(record.iof_rate * 100).toFixed(2)}}% ({{iof_value}})
                    <span class="silver-color">FX</span> {{(record.fx_rate * 100).toFixed(2)}}% ({{fx_value}})
                    <span class="silver-color" v-if="record.exchange_rate_spot">Spot</span> {{record.exchange_rate_spot}}
                    <span class="silver-color" v-if="record.exchange_rate_spot">VET</span> {{record.exchange_rate}}
                  </div>
                </v-flex>
                <v-flex xs6 sm2 py-0 text-sm-center order-xs8 order-sm7>
                  <span v-if="record.approved_by && record.is_canceled != true">{{record.approved_by.name}}</span>
                  <span v-if="!record.approved_by" class="silver-color">{{i18n('aprovação')}}</span>
                </v-flex>
                <v-flex xs6 sm2 py-0 text-xs-right order-xs4 order-sm8>
                  {{record.currency}} => {{record.exchange_currency}}
                </v-flex>

                <transition name="fade" v-if="hasBankTransactions">
                  <v-flex xs12 py-0 mt-3 v-if="current_view === 'detailed'" order-xs9 order-sm9>
                    <transaction
                    :record="transaction"
                    v-for="transaction in visibleTransactions"
                    :key="transaction.id"
                  />
                  </v-flex>
                </transition>

                <v-flex pb-2 pt-1 xs12 order-xs10 order-sm10 v-if="current_view === 'detailed' && !record.approved_by && hasBankTransactions">
                  <v-divider/>
                </v-flex>
                <v-flex xs12 style="display: flex;" order-xs11 order-sm11 v-if="current_view === 'detailed' && !record.approved_by">
                  <v-btn class="mb-0" dark style="flex: 1; background-color: var(--light-red-color);" @click.stop="deleteExchange">{{i18n(delete_btn_label)}}</v-btn>
                  <v-btn class="mb-0" dark style="flex: 2; background-color: var(--background-color);" @click.stop="approveExchange" v-if="is_admin" >{{i18n(approve_btn_label)}}</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-divider />
  </v-flex>
</template>

<script>
import utils from "./shared/Utils"
import TransactionItem from "./ExchangeTransactionItem"

export default {
  name: 'ExchangeItem',
  components: { 'transaction': TransactionItem },
  props: {
    record: {
      type: Object
    },
    is_admin: {
      type: Boolean
    }
  },
  data() {
    return {
      current_view: 'short',
      buttons_enabled: true,
      approve_btn_label: 'Aprovar',
      delete_btn_label: 'Excluir'
    }
  },
  computed: {
    receiver_social_name() {
      return this.record.to_bank_account.company && this.record.to_bank_account.company.social_name
    },
    humanExchangeDate() {
      return utils.dbDateTimeToHuman(this.record.inserted_at).split(' ')[0]
    },
    humanExchangeTime() {
      return utils.dbDateTimeToHuman(this.record.inserted_at).split(' ')[1]
    },
    hasBankTransactions() {
      return !!this.record.bank_transactions
    },
    visibleTransactions() {
      return (this.record.bank_transactions || []).filter(
        transaction => !transaction.is_canceled
      )
    },
    iof_value() {
      return this.l(this.record.iof_value, "BRL")
    },
    fx_value() {
      return this.l(this.record.fx_value, this.fx_value_currency)
    },
    fx_value_currency() {
      if (this.$root.isLocalCurrency(this.record.exchange_currency)) {
        return this.record.exchange_currency
      } else {
        return this.record.currency
      }
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    toogleView() {
      if (this.hasBankTransactions) {
        this.current_view = (this.current_view === 'short') ? 'detailed' : 'short'
      }
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    },
    disableButtons() {
      this.buttons_enabled = false
    },
    approveExchange() {
      if (this.buttons_enabled) {
        this.approve_btn_label = 'Aprovando'
        this.$emit('onApprove', this.record)
        this.$root.$emit('exchangeApproved')
        this.current_view = 'short'
        this.disableButtons()
      }
    },
    deleteExchange() {
      if (this.buttons_enabled) {
        this.delete_btn_label = 'Excluindo'
        this.$emit('onRemove', this.record)
        this.current_view = 'short'
        this.disableButtons()
      }
    }
  },
  mounted() {
  }
}
</script>

<style>
  .v-icon.blue_icon {
    color: #37517e;
  }
  .v-icon.grey_icon {
    color: #CCC;
  }
  .silver-color {
    color: var(--silver-color-font-color);
  }
</style>



// WEBPACK FOOTER //
// src/ExchangeItem.vue